import PaidIcon from "@mui/icons-material/Paid";
import { required, SelectInput, useNotify, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import { PaymentProvider } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";

const ReceivePaymentProviders = [
  {
    id: PaymentProvider.BankTransfer,
    name: "Банков превод",
  },
  {
    id: PaymentProvider.CashPayment,
    name: "В брой",
  },
];

const ReceivePaymentDialog = ({ candidacyId }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      candidateRequests.receivePaymentExpectation(),
      { candidacyId, paymentProviderId: data.paymentProviderId },
      "POST",
    );
    notify("Успешно получаване", { type: "success" });
    refresh();
  };
  return (
    <FormModal
      titleContent="Получаване на плащане"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          startIcon={<PaidIcon />}
          variant="contained"
          size="small"
          sx={{ margin: 0.5 }}
        >
          Платено
        </Button>
      }
    >
      <SelectInput
        source="paymentProviderId"
        label="Изберете начин на плащане"
        choices={ReceivePaymentProviders}
        validate={required()}
      />
    </FormModal>
  );
};

export default ReceivePaymentDialog;
